// Estado de erro de envio (rede ruim, timeout): mensagem clara e "TENTAR DE NOVO" SEM
// perder a gravação — o CapturaPage guarda o Blob e reusa. Sem mockup aprovado; mesma
// linguagem escura. "DESCARTAR" volta ao repouso (a gravação é perdida de propósito).

import { corC, fonteC, btnPrimarioC, btnSecundarioC } from '../../styles/tokensCelular';

interface Props {
  motivo: string;
  onTentar: () => void;
  onDescartar: () => void;
}

export function ErroEnvio({ motivo, onTentar, onDescartar }: Props): JSX.Element {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '24px 20px 0' }}>
        <span style={{ width: 12, height: 12, borderRadius: '50%', background: corC.vermelho, display: 'block' }} />
        <span
          style={{
            fontFamily: fonteC.condensada,
            fontWeight: 600,
            fontSize: 17,
            letterSpacing: '.18em',
            color: corC.texto,
          }}
        >
          FALHA NO ENVIO
        </span>
        <div style={{ height: 1, flex: 1, background: corC.divisor }} />
      </div>

      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '0 20px',
          gap: 12,
        }}
      >
        <div style={{ fontSize: 15, lineHeight: 1.55, color: corC.texto }}>{motivo}</div>
        <div style={{ fontSize: 12.5, color: corC.muted, lineHeight: 1.5 }}>
          Sua gravação continua guardada no aparelho. Tente enviar de novo.
        </div>
      </div>

      <div style={{ padding: '0 20px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <button type="button" onClick={onTentar} style={{ ...btnPrimarioC, height: 56, fontSize: 19 }}>
          TENTAR DE NOVO
        </button>
        <button
          type="button"
          onClick={onDescartar}
          style={{ ...btnSecundarioC, height: 48, fontSize: 16, letterSpacing: '.08em' }}
        >
          DESCARTAR GRAVAÇÃO
        </button>
      </div>
    </div>
  );
}
